import { toPX } from '#app/helpers/toPX';
import useWindowSize from '#app/hooks/useWindowSize';
import { FaqTabUpd } from '#components/index';

import styles from './index.module.scss';
import { faqs_data } from './data';

const FAQs = ({
 data, background, margin, padding 
}) => {
  const { isDesktop } = useWindowSize();

  return (
    <section
      className={styles.wrapper}
      style={{
        background: background && background, // Margin
        marginTop: margin && margin.top && toPX(isDesktop, margin.top),
        marginRight: margin && margin.right && toPX(isDesktop, margin.right),
        marginBottom: margin && margin.bottom && toPX(isDesktop, margin.bottom),
        marginLeft: margin && margin.left && toPX(isDesktop, margin.left),
        // Padding
        paddingTop: padding && padding.top && toPX(isDesktop, padding.top),
        paddingRight: padding && padding.right && toPX(isDesktop, padding.right),
        paddingBottom: padding && padding.bottom && toPX(isDesktop, padding.bottom),
        paddingLeft: padding && padding.left && toPX(isDesktop, padding.left)
      }}
    >
      <div className={styles.container}>
        <FaqTabUpd faqs={data ? data : faqs_data} fill={'red'} marginBottom={false} />
      </div>
    </section>
  );
};

export default FAQs;
